// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__z-d2O","text":"SelectPayment_text__q5Zjd","title":"SelectPayment_title__30OHM","btn":"SelectPayment_btn__2_Xia"};